import { PluginReview } from 'rwl-shared/dist/models';
import styled from 'styled-components6';
import {
    ReviewAuthorAvatar,
    ReviewAuthorNameContainer,
} from '../../../JobStory/JobReview/ReviewAuthor';
import { SourceIcon } from '../../../SourceIcon';
import { Body1, Body2, mqDown } from '../../../../theme';
import { ReviewRating } from '../../../ReviewRating';
import { When } from 'react-if';

const ReviewContainer = styled.div`
    margin: var(--rwl-spacing-sm) 0;
    ${mqDown('sm')} {
        display: block;
    }
    ${mqDown('xs')} {
        display: none;
    }
`;

const ReviewMessage = styled(Body1)`
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    ${mqDown('lg')} {
        display: none;
    }
`;

export const ReviewAuthorContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin-top: var(--rwl-spacing-sm);
`;

type JobCardReviewProps = {
    review?: PluginReview;
};

const SourceIconContainer = styled.div`
    background-color: var(--rwl-palette-white);
    height: 20px;
    width: 20px;
    border-radius: 50%;
    position: absolute;
    bottom: 0;
    right: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

// && is a specificity hack.  The rwl-text-body2 styling was trying to take priority
const AuthorName = styled(Body2)`
    && {
        color: var(--rwl-text-default);
        font-weight: 600;
    }
`;

export const JobCardReview = ({
    review,
}: JobCardReviewProps): JSX.Element | null => {
    if (!review) {
        return null;
    }

    const message = `"${review.message}"`;
    const showSourceIcon = review.source && review.source !== 'Internal';
    return (
        <ReviewContainer>
            <When condition={!!review.message}>
                <ReviewMessage>{message}</ReviewMessage>
            </When>
            <ReviewAuthorContainer>
                <div style={{ position: 'relative' }}>
                    {review.authorPhotoUrl && (
                        <ReviewAuthorAvatar
                            style={{
                                margin: 0,
                                marginRight: 'var(--rwl-spacing-sm)',
                            }}
                            size={'small'}
                            src={review.authorPhotoUrl}
                        />
                    )}
                    <When condition={showSourceIcon}>
                        <SourceIconContainer>
                            <SourceIcon source={review.source} />
                        </SourceIconContainer>
                    </When>
                </div>
                <ReviewAuthorNameContainer>
                    <AuthorName>{review.author}</AuthorName>
                    <ReviewRating size={'small'} rating={review.rating} />
                </ReviewAuthorNameContainer>
            </ReviewAuthorContainer>
        </ReviewContainer>
    );
};
